import { useCallback } from 'react';
import { VerificationType } from '@common/entities';

import { getVerificationStatus } from 'services';
import handleError from 'utils/handleError';

export const useFetchVerificationStatus = () => {
  const fetchVerificationStatus = useCallback(async (signal?: AbortSignal) => {
    try {
      const response = await getVerificationStatus(signal);
      return response;
    } catch (error: any) {
      // Don't log abort errors
      if (error?.name === 'AbortError' || error?.name === 'CanceledError') {
        throw error;
      }
      handleError('Form Viewer - ', error?.message);
      return {
        idVerification: { status: null, verificationType: VerificationType.IdentityVerification },
        incomeVerification: {
          status: null,
          verificationType: VerificationType.IncomeVerification,
        },
      };
    }
  }, []);

  return {
    fetchVerificationStatus,
  };
};
